// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-section {
    position: relative;
    width: 100%; /* You can adjust the height as needed */
}

.image-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    z-index: 1;
}

.overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(to top, rgb(0, 0, 0) 20%, rgba(255, 255, 255, 0) 90%);
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 20px;
 
}

.content {
    color: #fafafa;
    max-width: 80%;
    margin: 0 auto;
    margin-top: auto;
    margin-bottom: 30px;
}

.title {
    font-size: 3rem;
    margin: 0;
}

.subtitle {
    font-size: 5vw;
    margin: 0;
    font-weight: bold;
}

.description {
    font-size: 1.2rem;
    margin: 20px 0;
}

.cta-button {
    font-size: 1.1rem;
    padding: 10px 20px;
    background-color: #101010;
    color: #fafafa;
    text-decoration: none;
    border-radius: 5px;
    display: inline-block;
    margin-top: 20px;
    transition: background-color 0.3s;
}

.cta-button:hover {
    background-color: #fafafa;
    color: #101010;
}
`, "",{"version":3,"sources":["webpack://./src/components/CustomSection.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW,EAAE,wCAAwC;AACzD;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,2BAA2B;IAC3B,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,iFAAiF;IACjF,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;;AAEjB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,SAAS;AACb;;AAEA;IACI,cAAc;IACd,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,qBAAqB;IACrB,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB","sourcesContent":[".custom-section {\n    position: relative;\n    width: 100%; /* You can adjust the height as needed */\n}\n\n.image-bg {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-size: cover;\n    background-position: center;\n    z-index: 1;\n}\n\n.overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(to top, rgb(0, 0, 0) 20%, rgba(255, 255, 255, 0) 90%);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    padding: 20px;\n \n}\n\n.content {\n    color: #fafafa;\n    max-width: 80%;\n    margin: 0 auto;\n    margin-top: auto;\n    margin-bottom: 30px;\n}\n\n.title {\n    font-size: 3rem;\n    margin: 0;\n}\n\n.subtitle {\n    font-size: 5vw;\n    margin: 0;\n    font-weight: bold;\n}\n\n.description {\n    font-size: 1.2rem;\n    margin: 20px 0;\n}\n\n.cta-button {\n    font-size: 1.1rem;\n    padding: 10px 20px;\n    background-color: #101010;\n    color: #fafafa;\n    text-decoration: none;\n    border-radius: 5px;\n    display: inline-block;\n    margin-top: 20px;\n    transition: background-color 0.3s;\n}\n\n.cta-button:hover {\n    background-color: #fafafa;\n    color: #101010;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
